import type { WebhookMessageTemplateIdResult } from "@dashboardApi/apis/webhookMessageTemplateId/types";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";

export const getWebhookMessageTemplateId = reactQueryFetcherAdapter(
  cacheKey,
  async (signal: AbortSignal, templateId: string): Promise<WebhookMessageTemplateIdResult> => {
    return await fetch(`/engagement/webhook_templates/${templateId}`, "GET", undefined, { signal });
  }
);
